import React from 'react';
import styled from 'styled-components';
import { stripUnit } from 'polished';
import { white, brandColors, colorError, grey50, grey200 } from 'styles/colors';
import {
	pageToolbarHeight,
	appSideSpacing,
	dropdownSideSpacing,
} from 'styles/spacings';

const dividerHeight = '32px';

export const PageToolbar = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 ${appSideSpacing};
	height: auto;
	min-height: ${pageToolbarHeight};
	position: relative;
	z-index: ${({ zIndex }) => (zIndex != null ? zIndex : 2)};

	&::after {
		content: '';
		position: absolute;
		right: 0;
		bottom: 0;
		left: 0;
		height: 1px;
		background-color: ${grey200};
	}
`;

export const PageToolbarTitle = styled.h2`
	font-size: 16px;
	font-weight: bold;
	white-space: nowrap;
`;

export const PageToolbarControls = styled.div`
	display: flex;
	align-items: center;
`;

export const PageToolbarGapDivider = styled.span`
	width: ${dropdownSideSpacing};
	height: ${dividerHeight};
	display: inline-block;
`;

export const PageToolbarLineDivider = styled.span`
	margin: 0 ${dropdownSideSpacing};
	height: ${dividerHeight};
	width: 1px;
	background-color: ${grey50};
	display: inline-block;
`;

export const PageToolbarBlockButton = styled.button`
	outline: none;
	border: 0;
	height: ${dividerHeight};
	min-width: 120px;
	padding: 0 ${dropdownSideSpacing};
	font-weight: bold;
	text-transform: uppercase;
	font-size: 12px;
	background-color: ${grey200};
	color: ${white};
	transition: background-color 200ms ease-in-out;
	display: flex;
	align-items: center;
	justify-content: center;
	white-space: nowrap;

	&:not(:disabled) {
		cursor: pointer;
		background-color: ${brandColors.green};
	}
`;

export const PageToolbarNakedButton = styled(({ children, red, ...props }) => (
	<button {...props}>
		<NakedButtonText red={red}>{children}</NakedButtonText>
	</button>
))`
	background: transparent;
	border: 0;
	padding: 0;
	outline: none;
	color: ${props => (props.red ? colorError : 'inherit')};
	height: ${pageToolbarHeight};

	&:not(:disabled) {
		cursor: pointer;
	}
`;

const NakedButtonText = styled.span`
	text-transform: uppercase;
	font-size: 12px;
	font-weight: bold;
	border-bottom: 2px solid transparent;
	transition: 200ms ease-in-out;
	transition-property: border-color, opacity;
	white-space: nowrap;

	${PageToolbarNakedButton}:disabled & {
		opacity: 0.4;
	}

	${PageToolbarNakedButton}:not(:disabled):hover &,
	${PageToolbarNakedButton}:not(:disabled):focus & {
		border-color: currentColor;
	}
`;

export const PageToolbarTabButton = styled(
	({ children, selected, ...props }) => (
		<button selected={selected} {...props}>
			{children}
		</button>
	)
)`
	background: transparent;
	border: 0;
	margin: 0 -${stripUnit(dropdownSideSpacing) * 0.475}px;
	padding: 0 ${stripUnit(dropdownSideSpacing) * 0.475}px;
	outline: none;
	color: ${props => (props.selected ? brandColors.green : 'inherit')};
	height: ${pageToolbarHeight};
	text-transform: uppercase;
	font-size: 12px;
	font-weight: bold;
	border-top: 3px solid transparent;
	border-bottom: 3px solid transparent;
	transition: 200ms ease-in-out;
	transition-property: color, border-color, opacity;
	border-bottom-color: ${props =>
		props.selected ? 'currentColor' : 'transparent'};

	&:disabled {
		opacity: 0.4;
	}

	&:not(:disabled) {
		cursor: pointer;
	}

	&:not(:disabled):hover {
		border-bottom-color: ${props =>
			props.selected ? brandColors.green : grey200};
	}
`;
